"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskedParagraphPropertiesCache = void 0;
var tslib_1 = require("tslib");
var hash_based_cache_1 = require("../hash-based-cache");
var MaskedParagraphPropertiesCache = (function (_super) {
    tslib_1.__extends(MaskedParagraphPropertiesCache, _super);
    function MaskedParagraphPropertiesCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaskedParagraphPropertiesCache.prototype.copyFrom = function (obj) {
        _super.prototype.copyFrom.call(this, obj);
    };
    MaskedParagraphPropertiesCache.prototype.clone = function () {
        var result = new MaskedParagraphPropertiesCache();
        result.copyFrom(this);
        return result;
    };
    return MaskedParagraphPropertiesCache;
}(hash_based_cache_1.HashBasedCache));
exports.MaskedParagraphPropertiesCache = MaskedParagraphPropertiesCache;
